var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:[{expandable: _vm.expandable}, _vm.term.queryType]},[_vm._l((_vm.terms),function(p){return [_c('term',{attrs:{"term":p,"expandable":_vm.expandable,"show-class":_vm.showClass,"root-term":_vm.rootTerm}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }